<div class="buttons">
  @for (rk of rangeKeys; track rk) {
    <div class="popup-button"
      >
      <aa-popup-button [rangeKey]="rk"
        (buttonClicked)="onButtonClicked($event)">
      </aa-popup-button>
    </div>
  }
</div>
